import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom"; 
import toast from "react-hot-toast";
import cement from "../Images/cement.jpg";
import factory from "../Images/factory.jpg";
import "./sidebar.css"

function Sidebar() {
  const [activeLink, setActiveLink] = useState(null); // State to track active link
  const navigate = useNavigate();

  const handlClick = () => {
    document.querySelector(".sidebarwrap").classList.remove("show");
  };

  const handleLogOut = () => {
    toast.success("Logout Successful");
    localStorage.clear();
    navigate("/login");
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
    handlClick();
  };

  return (
    <>
      <section
        className="sidebarwrap"
        style={{
          backgroundImage: `url(${factory})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          
        }}
      >
        <div className="top_area">
          <button id="backbtnsidebar" onClick={handlClick}>
            <i className="fa-solid fa-arrow-left"></i>
          </button>

          <div className="logo_area">
            <div className="logo" style={{ borderRadius: "7px" }}>
              <img src={cement} className="img-fluid" alt="logo" style={{ borderRadius: "3px" }} />
            </div>
          </div>
        </div>

        <div className="sidebar_menu">
          <ul className="nav Menu_Nav accordion" id="sidemenu">
            <li className="menuline">
              <NavLink 
                to="/" 
                className="menu-link" 
                onClick={() => handleLinkClick('/')}
                style={activeLink === '/' ? { backgroundColor: 'rgb(208, 38, 38)', color: 'white' } : {}}
              >
                <i className="fa-solid fa-bars"></i>
                <span style={{ fontFamily: 'Roboto, sans-serif' }}>Dashboard</span>
              </NavLink>
            </li>

            <li className="menuline">
              <div 
                className="menu-head" 
                id="sidemenuhead1"
                onClick={() => handleLinkClick('/manageusers')}
                style={activeLink === '/manageusers' ? { backgroundColor: 'rgb(208, 38, 38)', color: 'white' } : {}}
              >
                <Link to="/manageusers" className="btn btn-header-link">
                  <i className="fa-solid fa-users"></i>
                  <span style={{ fontFamily: 'Roboto, sans-serif' }}>Manage Users</span>
                </Link>
              </div>
            </li>

            <li className="menuline">
              <div 
                className="menu-head" 
                id="sidemenuhead2"
                onClick={() => handleLinkClick('/managefaq')}
                style={activeLink === '/managefaq' ? { backgroundColor: 'rgb(208, 38, 38)', color: 'white' } : {}}
              >
                <Link to="/managefaq" className="btn btn-header-link">
                  <i className="fa-solid fa-question-circle"></i>
                  <span style={{ fontFamily: 'Roboto, sans-serif' }}>Manage FAQ</span>
                </Link>
              </div>
            </li>

            <li className="menuline">
              <div 
                className="menu-head" 
                id="sidemenuhead3"
                onClick={() => handleLinkClick('/managecontact')}
                style={activeLink === '/managecontact' ? { backgroundColor: 'rgb(208, 38, 38)', color: 'white' } : {}}
              >
                <Link to="/managecontact" className="btn btn-header-link">
                  <i className="fa-solid fa-address-card"></i>
                  <span style={{ fontFamily: 'Roboto, sans-serif' }}>Manage Contact</span>
                </Link>
              </div>
            </li>

            <li className="menuline">
              <div 
                className="menu-head" 
                id="sidemenuhead4"
                onClick={() => handleLinkClick('/termscondition')}
                style={activeLink === '/termscondition' ? { backgroundColor: 'rgb(208, 38, 38)', color: 'white' } : {}}
              >
                <Link to="/termscondition" className="btn btn-header-link">
                  <i className="fa-solid fa-file-contract"></i>
                  <span style={{ fontFamily: 'Roboto, sans-serif' }}>Manage T&C</span>
                </Link>
              </div>
            </li>

            <li className="menuline">
              <div 
                className="menu-head" 
                id="sidemenuhead5"
                onClick={() => handleLinkClick('/manageprojectitems')}
                style={activeLink === '/manageprojectitems' ? { backgroundColor: 'rgb(208, 38, 38)', color: 'white' } : {}}
              >
                <Link to="/manageprojectitems" className="btn btn-header-link">
                  <i className="fa-solid fa-tasks"></i>
                  <span style={{ fontFamily: 'Roboto, sans-serif' }}>Manage Project Items</span>
                </Link>
              </div>
            </li>

            <li className="menuline">
              <div 
                className="menu-head" 
                id="sidemenuhead6"
                onClick={() => handleLinkClick('/manageproject')}
                style={activeLink === '/manageproject' ? { backgroundColor: 'rgb(208, 38, 38)', color: 'white' } : {}}
              >
                <Link to="/manageproject" className="btn btn-header-link">
                  <i className="fa fa-product-hunt"></i>
                  <span style={{ fontFamily: 'Roboto, sans-serif' }}>Manage Project</span>
                </Link>
              </div>
            </li>
          </ul>

          <ul className="nav Account_Nav">
            <div onClick={handleLogOut} style={{ width: "100%" }}>
              <Link>
                <i className="fa-solid fa-right-from-bracket mr-2"></i>
                <span style={{ fontFamily: 'Roboto, sans-serif' }}>Logout</span>
              </Link>
            </div>
          </ul>
        </div>
      </section>
    </>
  );
}

export default Sidebar;
